import { holeResults } from '../../../engine';
import type { GameState } from '../../../engine';
import { fmt, worldFor } from '../../brand';
import type { SeatInfo } from '../../game/types';
import { label, totalOf } from '../../game/viewModel';
import { PlayerMedallion, WorldMedallion } from '../Art';

/** Columns are holes (headed by each world's medallion), rows are players, totals at right. */
export function Scorecard({ state, seats, me }: { state: GameState; seats: SeatInfo[]; me: number | null }) {
  const results = holeResults(state);
  const totals = state.players.map(totalOf);
  const low = Math.min(...totals);
  const anyPlayed = results.length > 0;
  const holes = Math.max(state.totalHoles, ...results.map((r) => r.hole));
  const cols = Array.from({ length: holes }, (_, i) => i + 1);
  const byHole = new Map(results.map((r) => [r.hole, r]));
  return (
    <div className="scorecard-wrap">
      <table className="scorecard">
        <caption className="sr-only">Scorecard</caption>
        <thead>
          <tr>
            <th scope="col" className="sc-name">
              <span className="sr-only">Player</span>
            </th>
            {cols.map((h) => {
              const playoff = h > state.totalHoles;
              return (
                <th key={h} scope="col" className={`sc-hole${h === state.hole ? ' now' : ''}`}>
                  <WorldMedallion world={worldFor(h, state.totalHoles)} size={20} />
                  <span className="num">{playoff ? `P${h - state.totalHoles}` : h}</span>
                </th>
              );
            })}
            <th scope="col" className="sc-total">
              Total
            </th>
          </tr>
        </thead>
        <tbody>
          {state.players.map((p, i) => (
            <tr key={i} className={i === me ? 'me' : ''}>
              <th scope="row" className="sc-name">
                <span className="sc-who">
                  <PlayerMedallion seat={i} size={18} />
                  <span>{seats[i]?.name || p.name || label(seats, me, i)}</span>
                </span>
              </th>
              {cols.map((h) => {
                const r = byHole.get(h);
                const s = r?.scores[i] ?? null;
                return (
                  <td key={h} className={`num${s !== null && r?.best.includes(i) ? ' best' : ''}`}>
                    {s === null ? '' : fmt(s)}
                  </td>
                );
              })}
              <td className={`num sc-total${anyPlayed && totals[i] === low ? ' leader' : ''}`}>{fmt(totals[i]!)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
